<template>
	<div id="main-content" role="main">
		<slot></slot>
	</div>
</template>

<script setup lang="ts"></script>
